import type { Dispatch, ReactNode, SetStateAction } from "react";
import { createContext, useContext } from "react";

import type { NewsletterSignUpClickTriggerPoint } from "scmp-app/components/tracking/google-analytics-4/types";

import type { NewsLetterUnsubscribePayload } from "./types";

type ContextValue = {
  ga4CustomParameter?: GA4CustomParameter;
  isEmbed?: boolean;
  setUnsubscribePayload?: Dispatch<SetStateAction<NewsLetterUnsubscribePayload | undefined>>;
};

type GA4CustomParameter = {
  triggerPoint?: NewsletterSignUpClickTriggerPoint;
};

const NewsletterLandingContext = createContext<ContextValue>({});

type Props = ContextValue & {
  children: ReactNode;
};

export const NewsletterLandingContextProvider: React.FunctionComponent<Props> = ({
  children,
  ...value
}) => (
  <NewsletterLandingContext.Provider value={value}>{children}</NewsletterLandingContext.Provider>
);

NewsletterLandingContext.displayName = "NewsletterLandingContext";

export const useNewsletterLandingContext = () => useContext(NewsletterLandingContext);
